<template>
    <div
    v-touch:swipe.left="hasExternalSwipe ? null : swipeLeft"
    v-touch:swipe.right="hasExternalSwipe ? null : swipeRight"
    class="slider-content-wrapper">
        <div ref="sliderRef" class="slider-wrapper">
            <card-bank
            v-for="(card, index) in cardsList"
            mobileSlider
            class="card-element"
            :key="`cardSliderElement${card.id}`"
            :params="card"
            :hideBalance="hideBalance"
            :selectedCardId="selectedCardId"
            :previousCard="index <= selectedCardIndex - 1"
            :nextCard="index === selectedCardIndex + 1"
            :hidePreviousCards="hidePreviousCards"
            @clicked="!getMobileAppState ? emit('clicked', $event) : null"/>
        </div>
        <!-- Circles to visually see our position in slider -->
        <navigation-circles-wrapper
        v-if="cardsList.length > 1"
        :listLength="cardsList.length"
        :selectedIndex="selectedCardIndex"/>
    </div>
</template>

<script setup>
import CardBank from '@/components/generic/cards/Bank'
import NavigationCirclesWrapper from '@/components/generic/sliders/navigation/CirclesWrapper.vue'
import { scrollTo } from '@/assets/scripts/scrollAnimation'

/* Vue */
import { ref, computed } from 'vue'

/* Emmitters */
const emit = defineEmits(['clicked'])

/* Props
@dashboardWidget {Boolean} - prop to apply logics for this to be used on dashboardWidget
@dashboardWidgetAnchor {Boolean} - prop to apply logics for this to be used on dashboardWidget Ancgor Variant
@selectedCardId {Number} - card id of selected card
@cardList {Array}
@hideBalance {Boolean} - flag to hide/show image with balances
*/
const props = defineProps({
	dashboardWidget: Boolean,
	dashboardWidgetAnchor: Boolean,
	selectedCardId: Number,
	cardsList: Array,
    hideBalance: Boolean
})

const sliderRef = ref('')
const selectedCardIndex = ref(props.cardsList.findIndex(obj => obj.id === props.selectedCardId))

const selectedCardId = computed(() => {
    return props.cardsList[selectedCardIndex.value].id
})

/*************************************************
 *                                                *
 *                Swipe/Move Handlers             *
 *                                                *
 *************************************************/
 const swipeLeft = () => {
    if (selectedCardIndex.value === (props.cardsList.length - 1)) return
    selectedCardIndex.value++
    moveLeft()
}

const swipeRight = () => {
    if (selectedCardIndex.value === 0) return
    selectedCardIndex.value--
    moveRight()
}

const moveLeft = () => {
    const newScrollPosition = ((214 + 8 /* gap */) * selectedCardIndex.value)
    emit('clicked', props.cardsList[selectedCardIndex.value].id)
    scrollTo(sliderRef.value, newScrollPosition, null, 1000, 'horizontal')
}

const moveRight = () => {
    const newScrollPosition = ((214 + 8 /* gap */) * selectedCardIndex.value)
    emit('clicked', props.cardsList[selectedCardIndex.value].id)
    scrollTo(sliderRef.value, newScrollPosition, null, 1000, 'horizontal')
}
</script>

<style lang="scss" scoped>
.slider-content-wrapper {
    width: 100%;
    height: 188px;

    display: flex;
    flex-direction: column;

    overflow: hidden;
    position: relative;

    .slider-wrapper {
        width: 100%;
        height: 100%;
        padding: 16px calc((100% - 240px) / 2) 24px calc((100% - 240px) / 2);

        display: flex;
        align-items: center;
        gap: 8px;
        overflow: hidden;
    }
}
</style>
